export default __webpack_public_path__ + "static/media/auto_dispatch.e15e3e59.svg";